<template>
  <section  @click="stopShow($event)" style="display: inherit" class="multipleSelectFather">
    <section :style="{'max-width': width ? width + '!important' : '','min-width': width ? width + '!important' : ''}" class="multipleSelect">
      <section v-if="!needSearch">
        <section :style="{'cursor':newDisabled? ' no-drop': 'pointer'}" :title="placeholder" @click="showDropFun" v-if="showSelectValue === '' && !newSelectValue" style="color: #ccc;" class="multipleSelectShowPlace">{{placeholder}}</section>
        <section :style="{'cursor':newDisabled? ' no-drop': 'pointer'}" :title="placeholder" @click="showDropFun" v-else-if="showSelectValue === '' && newSelectValue"  class="multipleSelectShowPlace">{{newSelectValue}}</section>
        <section :style="newDisabled ? 'cursor:no-drop;color:#666;' : 'cursor:pointer;color:#000;'"  :title="showSelectValue" v-else @click="showDropFun" class="multipleSelectShowPlace">
          <div style="display: inline-block" :key="index" v-for="(item, index) in showSelectValue.split(',')"><b v-if="index !== 0">,</b> {{item}}</div>
        </section>
      </section>
      <section v-else>
        <section :style="{'cursor':newDisabled? ' no-drop': 'pointer'}" :title="placeholder" @click="needSearchShowDropFun" v-if="showSelectValue === ''" style="color: #ccc;" class="multipleSelectShowPlace">
          <section>{{placeholder}}</section>
        </section>
        <section :style="newDisabled ? 'cursor:no-drop;color:#666;' : 'cursor:pointer;color:#000;'" :title="showSelectValue" v-else @click="needSearchShowDropFun" class="multipleSelectShowPlace">
          <section>{{showSelectValue}}</section>
        </section>
      </section>
      <section :id="randomId + '-cover'" style="display: none" class="selectCover"></section>
      <section :id="randomId" class="multipleSelectDrop">
        <section class="multipleSelectDropTitle textcenter">
          <!-- <section @click="cancelData" style="width: 40px;text-align: right">取消</section> -->
          <section class="f_w t_c" style="width: 100%;position:absolute;left:0;bottom:5px;">{{title || '请选择'}}</section>
          <!-- <section @click="clickConfirm" style="width: 40px">确定</section> -->
          <section class="closeBtn" @click="cancelData">
            <i class="icon iconfont iconarrow" style="color: #ac3027;font-weight:700;font-size: 26px!important;"></i>
          </section>
        </section>
        <!-- <section style="text-align: center" v-if="needSearch">
          <input placeholder="请输入文字搜索" @input="searchList" style="margin: 5px 0;width: 90%" class="allInput" type="text" v-model="searchKey">
        </section> -->
        <section :style="{'height': needSearch ? 'calc(100% - 90px)' : 'calc(100% - 75px)'}" style="overflow-y:auto; padding: 20px 5px;box-sizing: border-box;">
          <!-- <section v-if="shownothing" disabled="disabled" class="multipleSelectSelectData">没搜到任何值</section>
          <section @click="confirmData(item)" :class="item.checked ? 'active' : ''" class="multipleSelectSelectData" :key="index" v-for="(item, index) in selectData">
            {{returnShowValue(item)}}
            <p style="margin-top: 10px" v-if="returnShowValue(item) === '其它' && needOther">
              <textarea @blur="kickBack" style="width: calc(100% - 25px)" v-model="statusTextArea" class="allTextarea" ></textarea>
            </p>
          </section> -->
          <section v-for="(item, index) in groups" :key="index">
            <section class="group" v-if="item.groupData.length > 0">
              <p class="group-title">{{item.groupTitle}}</p>
              <section class="group-body">
                <div
                :style="(returnShowValue(val).length > 4 && returnShowValue(val).length < 11) ? 'width: 47%;' : (returnShowValue(val).length > 4 && returnShowValue(val).length > 10) ? 'width: 72%;' : ''"
                :class="{'group-prov': true, 'active-prov': val.checked}"
                v-for="(val, idx) in item.groupData"
                :key="idx"
                 @click="confirmData(val)">
                  {{returnShowValue(val)}}
                 </div>
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
let timeOut
let array = []
export default {
  name: 'cander',
  model: {
    prop: 'selectValue',
    event: 'selectValue'
  },
  props: [
    'needSearch',
    'multiple',
    'directPick',
    'selectValue',
    'chooseData',
    'needReturn',
    'showValue',
    'needOther',
    'matchValue',
    'placeholder',
    'width',
    'disabled',
    'item',
    'title',
    'textArea',
    'coverF'
  ],
  data () {
    return {
      chooseValue: '',
      other: false,
      shownothing: false,
      statusTextArea: this.textArea || '',
      newneedOther: this.needOther || '',
      newDisabled: this.disabled,
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000,
      newSelectValue: this.selectValue,
      searchValue: '',
      showSelectValue: '',
      selectData: this.chooseData,
      searchKey: '',
      groups: [
        {groupTitle: 'A-G', id: 1, groupData: [], groupLetters: ['a', 'b', 'c', 'd', 'e', 'f', 'g']},
        {groupTitle: 'H-K', id: 2, groupData: [], groupLetters: ['h', 'i', 'j', 'k']},
        {groupTitle: 'L-S', id: 3, groupData: [], groupLetters: ['l', 'm', 'n', 'o', 'p', 'q', 'r', 's']},
        {groupTitle: 'T-Z', id: 4, groupData: [], groupLetters: ['t', 'u', 'v', 'w', 'x', 'y', 'z']},
      ]
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    array = []
    this.handleData()
    console.log(this.selectData, 'selectData')
    this.splitDataByPinYin(this.selectData)
    console.log(this.needSearch, 'needSearch')
    console.log(this.disabled, 'disabled')
    console.log(this.newDisabled, 'newDisabled')
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
  },
  destroyed () {
  },
  methods: {
    searchList (e) {
      console.log(this)
      console.log(this.newneedOther)
      let multipleSelectSelectData = document.getElementById(this.randomId).querySelectorAll('.multipleSelectSelectData')
      for (let i = 0; i < multipleSelectSelectData.length; i++) {
        multipleSelectSelectData[i].style.display = 'none'
        if (multipleSelectSelectData[i].innerHTML.indexOf(e.target.value) >= 0 || multipleSelectSelectData[i].innerHTML.indexOf('其它') >= 0) {
          multipleSelectSelectData[i].style.display = 'block'
        }
      }
    },
    // 解决ios输入框失去焦点时不能回滚到顶部的问题
    kickBack () {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollTop + 1)
        document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1)
        if (document.getElementById('scorllNowPlace')) {
          window.scrollTo(0, document.getElementById('scorllNowPlace').scrollTop + 1)
          document.getElementById('scorllNowPlace').scrollTop >= 1 && window.scrollTo(0, document.getElementById('scorllNowPlace').scrollTop - 1)
        }
      }, 10)
    },
    clickConfirm () {
      let dom = document.getElementById(this.randomId)
      let domCover = document.getElementById(this.randomId + '-cover')
      dom.style.top = '100%'
      setTimeout(p => {
        dom.style.display = 'none'
        domCover.style.display = 'none'
      }, 200)
      this.$emit('textAreaValue', this.statusTextArea)
      this.$emit('on-confirm', '')
      if (this.other) {
        this.newSelectValue = this.statusTextArea
        this.showSelectValue = this.statusTextArea
        this.$emit('selectValue', this.newSelectValue)
      }
      this.searchKey = '' // 搜索框置空
    },
    cancelData () {
      let dom = document.getElementById(this.randomId)
      let domCover = document.getElementById(this.randomId + '-cover')
      dom.style.top = '100%'
      setTimeout(p => {
        dom.style.display = 'none'
        domCover.style.display = 'none'
      }, 200)
      this.$emit('selectValue', this.chooseValue)
      this.searchKey = '' // 搜索框置空
    },
    searchValueFun (e) {
      clearTimeout(timeOut)
      timeOut = setTimeout(p => {
        let searchValue = e.target.value
        let selDom = document.getElementById(this.randomId)
        let selList = selDom.querySelectorAll('.multipleSelectSelectData')
        let num = 0
        for (let i = 0; i < selList.length; i++) {
          if (searchValue === '') {
            selList[i].style.display = 'block'
          } else {
            selList[i].style.display = 'none'
            if (selList[i].innerHTML.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0) {
              selList[i].style.display = 'block'
            }
          }
          if (selList[i].style.display !== 'none') {
            num++
          }
        }
        if (num === 0) {
          this.shownothing = true
        } else {
          this.shownothing = false
        }
      }, 500)
    },
    backAllList () {
      let selDom = document.getElementById(this.randomId)
      let selList = selDom.querySelectorAll('.multipleSelectSelectData')
      for (let i = 0; i < selList.length; i++) {
        selList[i].style.display = 'block'
      }
      this.shownothing = false
    },
    handleData () {
      this.showSelectValue = ''
      let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.toString().split(',')
      if (this.selectData) {
        for (let i = 0; i < this.selectData.length; i++) {
          this.$set(this.selectData[i], 'checked', false)
          for (let j = 0; j < splitValue.length; j++) {
            if (this.selectData[i][this.needReturn].toString() === splitValue[j]) {
              // if (this.multiple) {
              //   this.selectData[i].checked = true
              // }
              this.selectData[i].checked = true
              this.showSelectValue += this.selectData[i][this.matchValue] + ','
            }
          }
        }
      }
      this.showSelectValue = this.showSelectValue.substring(0, this.showSelectValue.length - 1)
      if (this.selectValue && !this.showSelectValue) {
        this.showSelectValue = this.selectValue
        this.statusTextArea = this.showSelectValue
        for (let i = 0; i < this.selectData.length; i++) {
          if (this.selectData[i][this.needReturn].toString() === '其它' && this.needOther) {
            this.selectData[i].checked = true
          }
        }
      }
      console.log(this.selectValue, 'showValue')
      let html = this.showValue
      getItem(html)
    },
    confirmData (item) {
      console.log(item, 'confirmData----item')
      console.log(this.multiple, 'confirmData----this.multiple')
      if (this.multiple) {
        let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.split(',')
        console.log(splitValue)
        let splitshowSelectValue = this.showSelectValue === '' ? [] : this.showSelectValue.split(',')
        if (item[this.needReturn].toString() === '' && splitValue.length > 0) {
          splitValue = ['']
        }
        if (splitValue.indexOf(item[this.needReturn].toString()) >= 0) {
          splitValue.splice(splitValue.indexOf(item[this.needReturn].toString()), 1)
          splitshowSelectValue.splice(splitshowSelectValue.indexOf(item[this.needReturn].toString()), 1)
          let selectHmtl = ''
          let selectHmtl2 = ''
          for (let i = 0; i < splitValue.length; i++) {
            selectHmtl += splitValue[i] + ','
            selectHmtl2 += splitshowSelectValue[i] + ','
          }
          selectHmtl = selectHmtl.substring(0, selectHmtl.length - 1)
          selectHmtl2 = selectHmtl2.substring(0, selectHmtl2.length - 1)
          this.newSelectValue = selectHmtl
          this.showSelectValue = selectHmtl2
          this.$emit('selectValue', this.newSelectValue)
          if (this.item) {
            item.object = this.item
          }
          this.$emit('on-change', item)
        } else {
          if (this.newSelectValue === '') {
            this.newSelectValue += item[this.needReturn]
          } else {
            this.newSelectValue += ',' + item[this.needReturn]
          }
          this.$emit('selectValue', this.newSelectValue)
          if (this.item) {
            item.object = this.item
          }
          this.$emit('on-change', item)
          if (this.showSelectValue === '') {
            this.showSelectValue += item[this.matchValue]
          } else {
            this.showSelectValue += ',' + item[this.matchValue]
          }
        }
        this.handleData()
      } else {
        if (item[this.needReturn] === '其它' && this.needOther) {
          this.other = true
          this.directPick = false // 如果是其它需要手动点确定
        } else {
          this.other = false
          this.statusTextArea = ''
        }
        this.newSelectValue = item[this.needReturn]
        this.showSelectValue = item[this.matchValue]
        console.log(this.newSelectValue)
        this.$emit('selectValue', this.newSelectValue)
        if (this.item) {
          item.object = this.item
        }
        this.$emit('on-change', item)
        // let dom = document.getElementById(this.randomId)
        // dom.style.opacity = '0'
        // setTimeout(p => {
        //   dom.style.display = 'none'
        // }, 200)
      }
      if (this.directPick) {
        this.clickConfirm()
      }
    },
    needSearchShowDropFun () {
      if (!this.newDisabled) {
        this.backAllList()
        let dom = document.getElementById(this.randomId)
        let domCover = document.getElementById(this.randomId + '-cover')
        let domList = document.querySelectorAll('.multipleSelectFather')
        for (let i = 0; i < domList.length; i++) {
          // domList[i].style.zIndex = 1
        }
        // dom.parentNode.parentNode.style.zIndex = 2
        if (dom.style.display === 'none' || dom.style.display === '') {
          dom.style.display = 'block'
          domCover.style.display = 'block'
          setTimeout(p => {
            dom.style.top = '30%'
          }, 10)
        }
      }
    },
    showDropFun () {
      let qrcodeDom = document.getElementsByClassName('qrCode-container')
      if (!this.newDisabled) {
        this.chooseValue = this.selectValue
        let dom = document.getElementById(this.randomId)
        let domCover = document.getElementById(this.randomId + '-cover')
        if (dom.style.display === 'none' || dom.style.display === '') {
          dom.style.display = 'block'
          domCover.style.display = 'block'
          setTimeout(p => {
            if (qrcodeDom.length > 0) {
              dom.style.top = '16%'
            } else {
              dom.style.top = '0%' // 顶到最上面
            }
          }, 10)
        } else {
          dom.style.top = '100%'
          setTimeout(p => {
            dom.style.display = 'none'
            domCover.style.display = 'none'
          }, 200)
        }
      }
    },
    returnShowValue (object) {
      let html = this.showValue

      for (let i = 0; i < array.length; i++) {
        html = html.replace('{{' + array[i] + '}}', object[array[i]])
        html = this.returnShortName(html)
      }
      return html
    },
    stopShow (e) {
      e.stopPropagation()
    },
    // 数据分类 groups
    splitDataByPinYin (data) {
      for (let i = 0; i < data.length; i++) {
        let firstLetter = (data[i].PinYin).charAt(0)
        this.groups.forEach(item => {
          let flag = item.groupLetters.some(val => firstLetter.toLowerCase() == val)
          if (flag) {
            item.groupData.push(data[i])
            item.groupData = Array.from(new Set(item.groupData))
          }
        })
      }
      console.log(this.groups, 'this.groups')
    },
    returnShortName (longName) {
      let shortName = longName.replace(/省|市|自治区|特别行政区|壮族自治区|回族自治区|维吾尔/g,"")
      return shortName
    },
    initGroups () {
      this.groups.forEach(item => {
        item.groupData = []
      })
    }

  },
  watch: {
    textArea (value) {
      this.statusTextArea = value
    },
    selectValue (value) {
      this.newSelectValue = value
      this.showSelectValue = ''
      this.handleData()
      console.log(value)
    },
    chooseData (value) {
      this.initGroups()
      this.selectData = value
      this.splitDataByPinYin(this.selectData)
      this.handleData()
    },
    disabled (value) {
      this.newDisabled = value
    }
  },
  computed: {
  }
}
function getItem (html) {
  if (html.indexOf('{{') >= 0) {
    let aPos = html.indexOf('{{')
    let bPos = html.indexOf('}}')
    let newName = html.substr(aPos + 2, bPos - aPos - 2)
    array.push(newName)
    html = html.replace('{{', '').replace('}}', '')
    getItem(html)
  }
}
</script>

<style scoped>
  .selectCover{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    transition: all 0.3s;
    left: 0;
    opacity: 1;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
  }
  .multipleSelectFather{
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .multipleSelect{
    display: inline-block;
    position: relative;
    text-align: left;
    /*z-index: 5;*/
  }
  .multipleSelect .multipleSelectShowPlace {
    background-color: #fff;
    text-align: left;
    cursor: pointer;
    font-size: 16px;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .backWhite .multipleSelect .multipleSelectShowPlace {
    background-color: transparent!important;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectDropTitle {
    /* padding: 10px 0; */
    height: 70px;
    border-top: 4px solid #EF1201;
    border-bottom: 1px solid #eee;
    position: relative;
    overflow: hidden;
  }
  .closeBtn {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    /* 290602  3a0905*/
    background-color: #EF1201;
    text-align: center;
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    padding-top: 21px;
    box-sizing: border-box;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectDropTitle > section{
    display: inline-block;
  }
  .multipleSelect .multipleSelectDrop {
    position: fixed;
    top: 100%;
    left: 0;
    background: #fff;
    right: 0;
    display: none;
    transition: top 0.2s;
    bottom: 0;
    z-index: 1001;
    /* overflow: auto; */
    box-shadow: 0px 0px 5px 0px #ccc;
    border-radius: 4px;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData{
    padding: 15px 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData.active::after{
    content: '√';
    font-family: "微软雅黑", "Arial";
    position: absolute;
    right: 18px;
    width: 16px;
    height: 16px;
    border-radius: 20px;
    background: #ee1100;
    color: #fff;
    line-height: 12px;
    text-align: center;
    top: 16px;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData.active p{
    display: block;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData p{
    display: none;
  }
  /*.multipleSelect .multipleSelectDrop .multipleSelectSelectData.active {*/
  /*  color: #C50F3C;*/
  /*}*/
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData:hover{
    /*color: #fff;*/
    cursor: pointer;
    background: #f1f1f1;
  }
  .multipleSelectArror{
    position: absolute;
    right: 8px;
    top: 9px;
    color: #666;
    /*font-size: 10px;*/
  }
  /*@media screen and (max-width: 1370px) {*/
  /*  .multipleSelect {*/
  /*    max-width: 200px!important;*/
  /*    min-width: 200px!important;*/
  /*  }*/
  /*}*/
  .group-title {
    color: #9C9C9C;
    font-size: 22px;
    padding: 5px 5px 0 5px;
  }
  .group-body .group-prov {
    width: 22.2%;
    height: 35px;
    line-height: 35px;
    background-color: #EDEDED;
    text-align: center;
    border-radius: 5px;
    color: #666666;
    display: inline-block;
    margin: 5px;
    font-size: 16px;
  }
  .group-body .group-prov.active-prov {
    background-color: #EF1201;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/mobileProvinceCityPicker.vue